import React from 'react'
import { Badge } from '@/components/ui/Badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/Tooltip'
import { AlertTriangle } from 'lucide-react'
import type { OrgNodeData } from './NodeEditPanel'

interface Props {
  node: OrgNodeData
  /** Node has ProductSale rows but no sales flag — its sales are excluded from demand. */
  salesUnflagged: boolean
}

export default function ChannelBadges({ node, salesUnflagged }: Props) {
  if (!node.sales_channel && !node.wholesale && !salesUnflagged) return null
  return (
    <span className="inline-flex items-center gap-1">
      {node.sales_channel && <Badge variant="outline">Sales</Badge>}
      {node.wholesale && <Badge variant="outline">Wholesale</Badge>}
      {salesUnflagged && (
        <Tooltip>
          <TooltipTrigger asChild>
            <AlertTriangle className="h-3.5 w-3.5 text-warning" aria-label="Has sales, not flagged" />
          </TooltipTrigger>
          <TooltipContent>
            This node has recorded sales but is not flagged as a sales channel — those sales are excluded from demand.
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  )
}
